module.exports = __webpack_public_path__ + "static/qr-android-apk-1c3ef0edab13293b761f67f56ec98562.svg";